import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Copy from '../../../assets/copy.svg';
import {QRCodeSVG} from 'qrcode.react';
import { getStrLang } from '../../Translate';
import Loading from '../../../assets/loading.gif';
import { getPixInfo } from '../../../api/fastcoinService';
import toast, { Toaster } from 'react-hot-toast';
import 'jquery-ui-dist/jquery-ui';
import { AiOutlineEyeInvisible, AiFillEye } from 'react-icons/ai';

const PixQrSplited = (props) => {
    //Chamada para as variáveis e funções do Context
    const pix_avaliable = true;
    const { translate, lang, orderFromDeposit } = useLanguage();
    const [infoPix, setInfoPix] = useState();
    const [loadingPixInfo, setLoadingPixInfo] = useState(false);
    const [showInfo, setShowInfo] = useState(true);

    function simbleCurrency(){
        switch (sessionStorage.getItem("country").toLocaleUpperCase()) {
            case "BR":
                return "R$";
            case "AR":
                return "ARS$";
            case "CO":
                return "COL$";
            default:
                return "";
        }
    }

    //valida se os termos da ordem foram aceitos 
    useEffect(() => {
        function gerarPix() {
            function executarGeracaoPix() {
                let orderNumber = sessionStorage.getItem("order_no");
                let valor = (props.vSpt).replace(".", "").replace(",", ".");
                getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor)
                    .then(res => {
                        if (res !== undefined) {
                            setInfoPix(res);
                        } else {
                            setInfoPix({ error: "Please, talk with the Administrator." });
                        }
                    })
                    .catch(err => {
                        getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, true)
                            .then(res => {
                                if (res !== undefined) {
                                    setInfoPix(res);
                                    sessionStorage.setItem("pix_info", JSON.stringify(res));
                                    props.setWaitingPayment(true);
                                } else {
                                    setInfoPix({ error: "Please, talk with the Administrator." });
                                }
                                setLoadingPixInfo(false);
                                translate();
                            })
                            .catch(err => {
                                getPixInfo(orderNumber, getStrLang(lang.nameLang, "order_name") + " - " + orderNumber, valor, false,true)
                                    .then(res => {
                                        if (res !== undefined) {
                                            setInfoPix(res);
                                            sessionStorage.setItem("pix_info", JSON.stringify(res));
                                            props.setWaitingPayment(true);
                                        } else {
                                            setInfoPix({ error: "Please, talk with the Administrator." });
                                        }
                                        setLoadingPixInfo(false);
                                        translate();
                                    })
                                    .catch(err => {
                                        setInfoPix({ emv: "00020101021126580014br.gov.bcb.pix0136c9834cf4-31d3-4e14-9f03-7f6876e7cd215204000053039865802BR5912Mercado Easy6009SAO PAULO622905251H5WTE0YNK59CZ0FHZYGHMAB16304F73B" });
                                        console.log(err);
                                        setLoadingPixInfo(false);
                                        translate();
                                    })
                            })
                    })

            }
            setLoadingPixInfo(true);
            executarGeracaoPix();
        }
        if (orderFromDeposit !== "") {
            gerarPix();
        }
    }, []);

    //Traduz o texto na tela quando mudado o idioma pelo usuário
    useEffect(() => {
        translate();
    }, [translate]);

    const notify = () => {
        navigator.clipboard.writeText(infoPix.emv);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }

    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            {pix_avaliable ?
                <>
                    {infoPix !== undefined && infoPix.emv !== undefined ?
                        <div className='box-pix-splited-content'>
                            <div className='header-splited-option'>
                                <span style={{width: '2em'}}></span>
                                <span style={{fontWeight: "bold"}}>{simbleCurrency()} {(props.vSpt)}</span>
                                <button className="btn-eye-splited" onClick={() => { setShowInfo(!showInfo) }}>{showInfo ? <AiOutlineEyeInvisible size={20} /> : <AiFillEye size={20} />}</button>
                            </div>
                            {showInfo &&
                                <>
                                    <QRCodeSVG value={infoPix.emv} size={180} imageSettings={{src:"favicon.ico",height:40,width:40}}/>
                                    <div className="input-line-pix-splited">
                                        <input type="text" id={"pix_info"} className="form-control form-control-lg" value={infoPix.emv} />
                                        <div className="copy-area-pix-splited" onClick={() => notify()} data-balloon-visible aria-label={getStrLang(lang.nameLang, "information_pix_copy")} data-balloon-pos="down">
                                            <img src={Copy} alt="Copy" />
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        :
                        <>
                            {loadingPixInfo &&
                                <img src={Loading} alt={"loading"} width="30px" height="30px" />
                            }
                        </>
                    }
                    {/* <h4 className="div-info-pag" data-lang-str="information_pix"></h4>*/}
                </>
                :
                <h4 data-lang-str="information_pix"></h4>
            }
        </>
    )
}

export default PixQrSplited;